import z from 'zod';
import {FirestoreTimestamp, firestoreTimestampSchema} from '../_other/firestore/firestoreTimestampSchema';
import {ContactMessageState, contactMessageStateSchema} from './ContactMessageState';
import {ContactMessageWrite, contactMessageWriteSchema} from './contactMessageWriteSchema';

/** Document shape as stored in DB (id comes from Firestore document id when reading). */
export const contactMessageDbSchema = contactMessageWriteSchema.extend({
  uid: z.string().nullish().optional(),
  state: contactMessageStateSchema,
  createdAt: firestoreTimestampSchema,
});

export type ContactMessageDb = z.infer<typeof contactMessageDbSchema>;

/**
 * Create a db schema from a write schema.
 * @param write - The write schema to create a db schema from.
 * @param createdAt - The created at timestamp using serverTimestamp()
 * @returns
 */
export function createContactMessageDb(write: ContactMessageWrite, createdAt: FirestoreTimestamp): ContactMessageDb {
  return {
    ...write,
    state: ContactMessageState.UNREAD,
    /** use date as no firebase package in model package */
    createdAt,
  };
}
